import { render, staticRenderFns } from "./OrdersPaymentsList.vue?vue&type=template&id=2a810676&"
import script from "./OrdersPaymentsList.vue?vue&type=script&lang=js&"
export * from "./OrdersPaymentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports